<template>
  <fa-icon :icon="['fal', 'times'] " />
</template>